{
  "language": {
    "title": "Choisissez votre langue",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Bonjour, comment pouvons-nous vous aider ?",
    "checkIn": "Enregistrement",
    "independentManualCheckIn": "Sans rendez-vous",
    "integratedManualCheckIn": "Enregistrement manuel",
    "checkOut": "Départ",
    "manualCheckOut": "Départ manuel",
    "parcelDelivery": "Livraison de colis",
    "foodDelivery": "Livraison de nourriture",
    "callReception": "Appeler la réception",
    "overview": "Aperçu",
    "unavailable": "La réception est actuellement indisponible."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Choisissez une option pour vous enregistrer",
        "manual": "Enregistrement manuel",
        "code": "Enregistrement avec code PIN ou QR",
        "code-no-qr": "Enregistrement avec code PIN"
      },
      "checkout": {
        "title": "Choisissez une option pour partir",
        "manual": "Départ avec nom",
        "code": "Départ avec code PIN ou QR",
        "code-no-qr": "Départ avec code PIN"
      }
    },
    "title": "Vous pouvez maintenant scanner votre code QR ou saisir votre code PIN.",
    "orText": "Ou",
    "qrScanner": {
      "checkin": {
        "title": "Choisissez une option pour vous enregistrer"
      },
      "checkout": {
        "title": "Choisissez une option pour partir"
      },
      "btn": "Scanner votre code QR"
    },
    "hidScanner": {
      "title": "Présentez le code QR au scanner ci-dessous ou saisissez votre code PIN"
    },
    "pinOnly": {
      "title": "Veuillez saisir votre code PIN"
    },
    "pinCode": "Saisissez votre code PIN",
    "manually": {
      "checkin": "Vous n'avez pas de code d'enregistrement ?"
    },
    "status": {
      "idle": {
        "title": "Votre code est en cours de scan.",
        "message": "Veuillez patienter...",
        "nfc": {
          "title": "Votre badge est en cours de lecture.",
          "message": "Veuillez patienter..."
        }
      },
      "loading": {
        "title": "Votre code est en cours de scan.",
        "message": "Veuillez patienter...",
        "nfc": {
          "title": "Votre badge est en cours de lecture.",
          "message": "Veuillez patienter..."
        }
      },
      "error": {
        "title": "Votre code n'est pas valide.",
        "message": "Veuillez réessayer !",
        "nfc": {
          "title": "Votre badge est invalide.",
          "message": "Veuillez réessayer !"
        },
        "meeting": {
          "tooEarly": {
            "title": "Vous êtes un peu en avance",
            "message": "Votre code est valide à partir de {{validFromTime}}. La réunion commence à {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Ce code a expiré",
            "message": "La réunion s'est terminée à {{meetingEndTime}}. Votre code était valide jusqu'à {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Vous vous êtes enregistré avec succès.",
            "message": "Merci."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Vous vous êtes enregistré avec succès.",
              "message": "Merci."
            },
            "email-sms": {
              "title": "Vous vous êtes enregistré avec succès.",
              "message": "Votre personne de contact a été notifiée."
            },
            "call-ping": {
              "title": "Vous vous êtes enregistré avec succès.",
              "message": "Nous allons maintenant établir un appel téléphonique avec votre personne de contact."
            },
            "teams-call": {
              "title": "Vous vous êtes enregistré avec succès.",
              "message": "Nous allons maintenant établir un appel Microsoft Teams avec votre personne de contact."
            },
            "badge": {
              "title": "Merci pour votre enregistrement, votre badge va être imprimé.",
              "message": ""
            },
            "video-call": {
              "title": "Vous vous êtes enregistré avec succès.",
              "message": "Configuration de votre appel vidéo avec la personne de contact."
            }
          },
          "Employee": {
            "title": "Vous vous êtes enregistré avec succès.",
            "message": "Merci.",
            "badge": {
              "title": "Merci pour votre enregistrement, votre badge va être imprimé.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Vous vous êtes enregistré avec succès.",
            "message": "Merci.",
            "badge": {
              "title": "Merci pour votre enregistrement, votre badge va être imprimé.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Vous êtes parti avec succès.<br/>",
            "message": "À bientôt."
          },
          "MeetingAttendee": {
            "title": "Vous êtes parti avec succès.",
            "message": "À bientôt."
          },
          "Employee": {
            "title": "Vous êtes parti avec succès.",
            "message": "À bientôt."
          },
          "Visitor": {
            "title": "Vous êtes parti avec succès.",
            "message": "À bientôt."
          },
          "access": {
            "title": "Vous êtes parti avec succès.",
            "message": "Vous pouvez maintenant ouvrir la porte."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Encore quelques informations avant l'enregistrement",
    "subtitle": "Les champs marqués d'un * sont obligatoires",
    "btn": "S'enregistrer",
    "placeholder": {
      "other": "Autre...",
      "otherInput": "Saisissez votre option"
    },
    "error": {
      "required": "Vous n'avez pas rempli ce champ",
      "email": "Adresse e-mail non valide",
      "phone": "Numéro de téléphone non valide"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Veuillez remplir.",
      "documentScanner": "Faites attention lorsque vous insérez votre carte d'identité:"
    },
    "subtitle": {
      "default": "Remarque - chaque champ * est requis",
      "documentScanner": [
        {
          "parts": [
            { "text": "Le ", "bold": false },
            { "text": "côté avec les caractères <<< >>> (MRZ) ", "bold": true },
            { "text": "doit être ", "bold": false },
            { "text": "orienté vers le kiosque / scanner.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Gardez la carte immobile ", "bold": false },
            {
              "text": "jusqu'à ce que les champs soient remplis automatiquement.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Aucune option",
    "btn": "S'enregistrer",
    "placeholder": {
      "name": "Votre nom *",
      "email": "Votre e-mail *",
      "phone": "Numéro de portable",
      "contactName": "Votre personne de contact*",
      "other": "Autre..."
    },
    "error": {
      "required": "Vous n'avez pas rempli ce champ",
      "name": "Nom invalide",
      "email": "Adresse e-mail invalide",
      "phone": "Numéro de portable invalide"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Veuillez patienter...",
          "message": "Votre inscription est en cours de traitement."
        },
        "contact": {
          "title": "Veuillez patienter...",
          "message": "Votre contact est en cours de notification."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Veuillez patienter...",
          "message": "Votre inscription est en cours de traitement."
        },
        "contact": {
          "title": "Veuillez patienter...",
          "message": "Votre contact est en cours de notification."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Vous vous êtes enregistré avec succès.",
          "message": "Merci."
        },
        "email-sms": {
          "title": "Vous vous êtes enregistré avec succès.",
          "message": "Votre personne de contact est notifiée."
        },
        "call-ping": {
          "title": "Vous vous êtes enregistré avec succès.",
          "message": "Nous allons maintenant établir un appel téléphonique avec votre personne de contact."
        },
        "teams-call": {
          "title": "Vous vous êtes enregistré avec succès.",
          "message": "Nous allons maintenant établir un appel Microsoft Teams avec votre personne de contact"
        },
        "badge": {
          "title": "Merci pour votre enregistrement, votre badge va être imprimé.",
          "message": ""
        },
        "video-call": {
          "title": "Vous vous êtes enregistré avec succès.",
          "message": "Configuration de votre appel vidéo avec la personne de contact."
        }
      },
      "error": {
        "title": "Quelque chose a mal tourné.",
        "message": "Veuillez réessayer !"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Document non valide",
        "message": "Le document n’a pas pu être vérifié ou a expiré. Veuillez saisir vos informations manuellement."
      }
    }
  },
  "manualCheckout": {
    "title": "Saisissez votre nom pour partir",
    "btn": "Partir",
    "form": {
      "placeholder": {
        "name": "Votre nom complet *"
      },
      "loading": "Chargement...",
      "noOptions": "Aucune option"
    },
    "error": {
      "required": "Vous n'avez pas rempli ce champ",
      "name": "Nom invalide"
    },
    "status": {
      "idle": {
        "title": "Nous traitons vos informations.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous traitons vos informations.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "Vous êtes parti avec succès.",
        "message": "Merci et bonne journée."
      },
      "successAccess": {
        "title": "Vous êtes parti avec succès.",
        "message": "Vous pouvez maintenant ouvrir la porte."
      },
      "error": {
        "title": "Une erreur s'est produite lors du départ.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Souhaitez-vous notifier votre contact ?",
      "email-sms": "Nous avons envoyé un e-mail/SMS à votre contact.<br/>Voulez-vous en plus établir un appel avec eux ?"
    },
    "callBtn": "Appeler",
    "pingBtn": "Signal",
    "smsBtn": "SMS",
    "callVideoBtn": "Appel vidéo",
    "teamsCallBtn": "Appel Teams",
    "teamsMessageBtn": "Message Teams",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Annuler",
    "cancelBtn": "Annuler l'appel",
    "status": {
      "connecting": {
        "title": "Établissement de l'appel.<br/>Veuillez patienter...",
        "message": ""
      },
      "ringing": {
        "title": "Appel de votre personne de contact<br/>Veuillez patienter...",
        "message": ""
      },
      "ringingReception": {
        "title": "Appel démarré...",
        "message": ""
      },
      "open": {
        "title": "Appel en cours.",
        "message": ""
      },
      "close": {
        "title": "Appel terminé.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Appel terminé.<br/>Vous pouvez maintenant ouvrir la porte.",
        "message": ""
      },
      "closeReception": {
        "title": "L'appel est terminé.",
        "message": ""
      },
      "error": {
        "title": "L'appel n'est pas établi.<br/>Rappeler ?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Nous notifions votre personne de contact.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous notifions votre personne de contact.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "SMS envoyé. Le contact a été notifié.",
        "message": "Merci !"
      },
      "successAccess": {
        "title": "SMS envoyé. Le contact a été notifié.",
        "message": "Vous pouvez maintenant ouvrir la porte."
      },
      "error": {
        "title": "SMS non envoyé.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "videoCall": {
    "title": "Appel vidéo",
    "endCall": "Raccrocher",
    "status": {
      "idle": {
        "title": "Nous créons une salle vidéo.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous créons une salle vidéo.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "La salle vidéo a été créée avec succès.",
        "message": "Rejoindre la salle..."
      },
      "error": {
        "title": "La salle vidéo n'a pas été créée avec succès.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "teamsCall": {
    "title": "Appel Teams",
    "controls": {
      "startCall": "Commencer l'appel",
      "endCall": "Quitter",
      "camera": "Caméra",
      "cameraOff": "Caméra éteinte",
      "mic": "Micro",
      "micOff": "Micro éteint",
      "ringing": "Sonnerie...",
      "noAnswer": "Personne n'a répondu à l'appel."
    },
    "status": {
      "connecting": {
        "title": "Établissement de l'appel.<br/>Veuillez patienter...",
        "message": ""
      },
      "ringing": {
        "title": "Appel de votre personne de contact<br/>Veuillez patienter...",
        "message": ""
      },
      "connected": {
        "title": "Établissement de l'appel",
        "message": ""
      },
      "disconnected": {
        "title": "Appel terminé.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Appel terminé.<br/>Vous pouvez maintenant ouvrir la porte.",
        "message": ""
      },
      "error": {
        "title": "L'appel n'est pas établi.<br/>Veuillez réessayer",
        "message": ""
      },
      "noAnswer": {
        "title": "Personne n'a répondu à l'appel.<br/>Veuillez réessayer.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Nous notifions votre personne de contact.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous notifions votre personne de contact.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "Message envoyé. Le contact a été notifié.",
        "message": "Merci !"
      },
      "successAccess": {
        "title": "Message envoyé. Le contact a été notifié.",
        "message": "Vous pouvez maintenant ouvrir la porte."
      },
      "error": {
        "title": "Message non envoyé.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Nous notifions votre personne de contact.",
        "message": "Veuillez patienter..."
      },
      "loading": {
        "title": "Nous notifions votre personne de contact.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "title": "Message envoyé. Le contact a été notifié.",
        "message": "Merci !"
      },
      "successAccess": {
        "title": "Message envoyé. Le contact a été notifié.",
        "message": "Vous pouvez maintenant ouvrir la porte."
      },
      "error": {
        "title": "Message non envoyé.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "packageDelivery": {
    "title": "Comme c'est gentil de livrer un colis !",
    "subtitle": "Sélectionnez et notifiez le destinataire",
    "subtitle1": "Appuyez sur le bouton ci-dessous pour nous faire savoir que vous êtes là !",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Pour qui est le colis"
      },
      "error": {
        "contact": {
          "required": "Vous n'avez pas rempli ce champ"
        }
      }
    },
    "button": {
      "submit": "Notifier"
    },
    "status": {
      "loading": {
        "title": "Nous notifions la personne de contact.",
        "message": "Veuillez patienter..."
      },
      "success": {
        "no-email-sms": {
          "title": "Merci pour votre livraison !",
          "message": ""
        },
        "email-sms": {
          "title": "La personne de contact a été notifiée.",
          "message": "Merci pour votre livraison !"
        },
        "call-ping": {
          "title": "Merci pour votre livraison !",
          "message": "Une connexion téléphonique va maintenant être établie avec la personne de contact."
        },
        "teams-call": {
          "title": "Merci pour votre livraison !",
          "message": "Un appel Microsoft Teams va maintenant être établi avec votre personne de contact."
        },
        "video-call": {
          "title": "Merci pour votre livraison !",
          "message": "Configuration de votre appel vidéo avec la personne de contact."
        }
      },
      "error": {
        "title": "Quelque chose a mal tourné.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "foodDelivery": {
    "title": "Comme c'est gentil de livrer de la nourriture !",
    "subtitle": "Sélectionnez et notifiez le destinataire",
    "subtitle1": "Appuyez sur le bouton ci-dessous pour nous faire savoir que vous êtes là !",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Pour qui est la nourriture"
      },
      "error": {
        "contact": {
          "required": "Vous n'avez pas rempli ce champ"
        }
      }
    },
    "button": {
      "submit": "Notifier"
    },
    "status": {
      "loading": {
        "title": "Nous notifions le contact.",
        "message": "Veuillez patienter !"
      },
      "success": {
        "no-email-sms": {
          "title": "Merci pour votre livraison !",
          "message": ""
        },
        "email-sms": {
          "title": "Le contact est notifié.",
          "message": "Merci pour votre livraison !"
        },
        "call-ping": {
          "title": "Merci pour votre livraison !",
          "message": "Une connexion téléphonique va maintenant être établie avec votre personne de contact."
        },
        "teams-call": {
          "title": "Merci pour votre livraison !",
          "message": "Un appel Microsoft Teams va maintenant être établi avec votre personne de contact."
        },
        "video-call": {
          "title": "Merci pour votre livraison !",
          "message": "Configuration de votre appel vidéo avec la personne de contact."
        }
      },
      "error": {
        "title": "Quelque chose a mal tourné.",
        "message": "Veuillez réessayer !"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Veuillez scanner votre code QR",
    "subtitle": "Alignez le code QR à l'intérieur des coins rouges et gardez votre téléphone stable.",
    "error": "Format de code QR invalide",
    "unknownError": "Erreur inconnue lors du scan"
  },
  "common": {
    "backBtn": "Retour"
  },
  "previewPDF": {
    "page": {
      "of": "de",
      "previous": "Précédent",
      "next": "Suivant"
    },
    "button": {
      "cancel": "Annuler",
      "accept": "Accepter",
      "next": "Suivant"
    },
    "title": {
      "consent": "Consentement requis"
    }
  },
  "offline": {
    "title": "Hors ligne",
    "receptionMessage": "La réception numérique est hors ligne pour le moment et ne peut pas être utilisée, la connexion internet doit être vérifiée !",
    "check": "Êtes-vous un visiteur et souhaitez-vous parler directement à un employé ? Veuillez appeler {{receptionistPhone}}"
  },
  "overview": {
    "title": "Saisissez le code pour ouvrir l'aperçu !",
    "noUsers": "Aucune inscription",
    "status": {
      "success": {
        "title": "Le code est valide.",
        "message": ""
      },
      "error": {
        "title": "Le code est invalide.",
        "message": "Veuillez réessayer !"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Veuillez patienter...",
        "message": ""
      },
      "success": {
        "title": "Départ réussi.",
        "message": ""
      },
      "error": {
        "title": "Quelque chose a mal tourné.",
        "message": "Veuillez réessayer !"
      }
    },
    "listTitle": "Liste des personnes qui se sont enregistrées aujourd'hui mais ne sont pas parties",
    "page": "Page ",
    "table": {
      "head": {
        "fullName": "Nom",
        "type": "Type",
        "checkedinAt": "Enregistré à",
        "host": "Hôte"
      },
      "type": {
        "Package": "Livraison de colis",
        "Food": "Livraison de nourriture",
        "Visitor": "Visiteur",
        "MeetingAttendee": "Visiteur invité",
        "Employee": "Employé",
        "Guest": "Visiteur"
      }
    },
    "confirmModal": {
      "title": "Êtes-vous sûr de vouloir faire partir {{fullName}} ?",
      "cancel": "Annuler",
      "checkout": "Faire partir"
    }
  },
  "wifi": {
    "title": "Se connecter au réseau Wi-Fi"
  },
  "door": {
    "external": {
      "title": "Ouverture de la porte",
      "subtitle": "La porte va s'ouvrir sous peu. Veuillez patienter..."
    },
    "control": {
      "title": "Vous pouvez maintenant ouvrir la porte",
      "subtitle": "Veuillez appuyer sur le bouton ci-dessous !",
      "openBtn": "Ouvrir la porte"
    },
    "status": {
      "success": {
        "title": "La porte a été ouverte",
        "message": ""
      },
      "error": {
        "title": "Quelque chose a mal tourné",
        "message": "Veuillez contacter votre personne de contact pour ouvrir la porte."
      },
      "loading": {
        "title": "Ouverture de la porte...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Souhaitez-vous prendre une photo dans le cadre de votre processus d'enregistrement ?",
    "required": {
      "title": "Vérification photo requise !",
      "instructions": "Veuillez vous placer devant la caméra et suivre les instructions à l'écran.",
      "securityNotice": "Pour des raisons de sécurité et de vérification, une photo est requise lors de l'enregistrement.",
      "privacyInfo": "Nous respectons votre vie privée. Vos données sont stockées en toute sécurité et utilisées uniquement pour l'identification.",
      "closingMessage": "Merci pour votre coopération."
    },
    "optional": {
      "title": "Souhaitez-vous prendre une photo dans le cadre de votre processus d'enregistrement ?",
      "instructions": "",
      "securityNotice": "Prendre une photo peut aider à rationaliser l'identification et améliorer la sécurité.",
      "privacyInfo": "Nous respectons votre vie privée. Cette étape est optionnelle, et vos données seront traitées en toute sécurité.",
      "closingMessage": "Vous pouvez ignorer cette étape si vous préférez."
    },
    "subtitle": "Veuillez vous positionner dans le cadre et rester immobile pour un meilleur résultat",
    "button": {
      "cancel": "Annuler",
      "accept": "Accepter",
      "skip": "Ignorer",
      "next": "Suivant",
      "recapture": "Reprendre la photo",
      "continue": "Continuer"
    },
    "error": "Une erreur s'est produite lors de la capture de la photo. Le processus d'enregistrement se poursuivra sans la photo."
  },
  "wayfinding": {
    "title": "Où souhaitez-vous aller ?"
  },
  "callingMenu": {
    "title": "Menu d'appel"
  },
  "bell": {
    "status": {
      "success": {
        "title": "La sonnette retentit",
        "message": "Quelqu’un arrive bientôt."
      },
      "error": {
        "title": "Une erreur s'est produite",
        "message": "Veuillez réessayer"
      },
      "loading": {
        "title": "Connexion...",
        "message": "Veuillez patienter"
      }
    }
  },
  "access": {
    "control": {
      "title": "Vous pouvez maintenant ouvrir la porte",
      "subtitle": "Veuillez appuyer sur le bouton ci-dessous.",
      "titleAuto": "Accès automatique à la porte",
      "subtitleAuto": "La porte s'ouvrira automatiquement pour vous",
      "openBtn": "Ouvrir"
    },
    "status": {
      "success": {
        "title": "La porte a été ouverte",
        "message": ""
      },
      "error": {
        "title": "Quelque chose a mal tourné",
        "message": "Veuillez contacter votre personne de contact pour ouvrir la porte."
      },
      "loading": {
        "title": "Ouverture de la porte...",
        "message": ""
      }
    }
  }
}
